import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteGood($id: ID!) {
        deleteGood(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
